import { ActionStepContentType } from 'constants/aiChat';

import {
  isConfirmActionsContentProps,
  isErrorContentProps,
  isListContentProps,
  isScannedSectionsContentProps,
  isStepSummaryContentProps,
  isTextContentProps,
  isToolCallsContentProps,
} from '../../ActionStep.utils';

import ConfirmActionsContent from './ConfirmActionsContent';
import ErrorContent from './ErrorContent';
import ListContent from './ListContent';
import ScannedSectionsContent from './ScannedSectionsContent';
import StepSummaryContent from './StepSummaryContent';
import TextContent from './TextContent';
import ToolCallsContent from './ToolCallsContent';

export const subStepContentTypeGuardMap = {
  [ActionStepContentType.TEXT]: isTextContentProps,
  [ActionStepContentType.CONFIRM_ACTIONS]: isConfirmActionsContentProps,
  [ActionStepContentType.LIST]: isListContentProps,
  [ActionStepContentType.ERROR]: isErrorContentProps,
  [ActionStepContentType.STEP_SUMMARY]: isStepSummaryContentProps,
  [ActionStepContentType.SCANNED_SECTIONS]: isScannedSectionsContentProps,
  [ActionStepContentType.TOOL_CALLS]: isToolCallsContentProps,
};

export const subStepContentComponentMap = {
  [ActionStepContentType.TEXT]: TextContent,
  [ActionStepContentType.CONFIRM_ACTIONS]: ConfirmActionsContent,
  [ActionStepContentType.LIST]: ListContent,
  [ActionStepContentType.ERROR]: ErrorContent,
  [ActionStepContentType.STEP_SUMMARY]: StepSummaryContent,
  [ActionStepContentType.SCANNED_SECTIONS]: ScannedSectionsContent,
  [ActionStepContentType.TOOL_CALLS]: ToolCallsContent,
};
